import Vue from 'vue'

const marlonApi = function(ctx) {
  return {
    getAccount: () => {
      return ctx.$axiosMarlon.get('account').catch((error) => {
        throw error
      })
    },
    login: (jwt, isAccessToken) => {
      let credentials = {}
      if (isAccessToken) {
        credentials.accessToken = jwt
      } else {
        credentials = { jwt }
      }
      return ctx.$axiosMarlon.post('auth', credentials).catch((error) => {
        throw error
      })
    },
    shortListInstallations: (nextPage) => {
      return ctx.$axiosMarlon
        .get('account/installation', {
          params: { page: nextPage || null, pagesize: 1 }
        })
        .catch((error) => {
          throw error
        })
    },
    listInstallations: (nextPage) => {
      return ctx.$axiosMarlon.get('account/installation', {
        params: { page: nextPage || null, pagesize: 10 }
      })
    },
    installationDetail: (installationId) => {
      return ctx.$axiosMarlon.get(`account/installation/${installationId}`)
    },
    getCustomerInfo: (accessToken) => {
      if (!accessToken) return null
      if (process.env.isMockData) {
        return ctx.$mockiOApi.getCustomerInfo(
          `registration-info?onecta_access_token=${accessToken}`
        )
      } else {
        return ctx.$axiosMarlon.get(
          `registration-info?onecta_access_token=${accessToken}`
        )
      }
    },
    registerInstallation: (request) => {
      return ctx.$axiosMarlon.post('account/installation', request)
    },
    addUnitToRegisteredInstallation: (installationId, unit) => {
      return ctx.$axiosMarlon.post(
        `account/installation/${installationId}/unit`,
        unit
      )
    },
    validateCommissioningCode: (code) => {
      return ctx.$axiosMarlon.get(`account/installation/validate/${code}`)
    },
    listPackages: (installationId) => {
      return ctx.$axiosMarlon.get(
        `account/installation/${installationId}/packages`
      )
    },
    updateServicePartner: (installationId, servicePartnerId) => {
      return ctx.$axiosMarlon.put(
        `account/installation/${installationId}/service-partner`,
        { installer_id: servicePartnerId }
      )
    },
    retrieveCheckoutData(installationId, packageId) {
      return ctx.$axiosMarlon.put(
        `account/installations/${installationId}/packages/${packageId}`
      )
    },
    getPurchaseData(purchaseId) {
      return ctx.$axiosMarlon.get(`account/purchases/${purchaseId}`)
    },
    termsOfPackage(installationId, packageId) {
      return ctx.$axiosMarlon
        .get(
          `account/installation/${installationId}/packages/${packageId}/terms`
        )
        .catch((error) => console.error(error))
    },
    validateUnit: (units) => {
      const apiUnits = units.map((u) => {
        return {
          material_code: u.material,
          serial_number: u.serial
        }
      })
      return ctx.$axiosMarlon.post('account/units', apiUnits)
    },
    resentInvitationEmail: (installationId) => {
      return ctx.$axiosMarlon.get(`account/invitation/${installationId}`)
    },
    productRangeSearch: (units, country, language) => {
      const apiUnits = units.map((u) => {
        return {
          material_code: u.material,
          serial_number: u.serial
        }
      })
      return ctx.$axiosMarlon.post(
        `account/product-range`,
        {
          units: apiUnits
        },
        {
          params: {
            country: country || null,
            language: language || null
          }
        }
      )
    },
    searchPostalCode: (query) => {
      return ctx.$axiosMarlon.get(`postalcode`, {
        params: { search: query || '' }
      })
    },
    searchMaterialCode: (query, country, language) => {
      return ctx.$axiosMarlon.get(`materialcodes`, {
        params: {
          search: query || '',
          country: country || null,
          language: language || null,
          // New implementation by IO to get array of objects instead of plain array
          new_response_format: true
        }
      })
    },
    searchServicePartner: (query, installationId) => {
      return ctx.$axiosMarlon.get(`account/service-partners`, {
        params: { search: query || '', installation_id: installationId || null }
      })
    },
    getLaunchUrl: (language, country) => {
      const simplifiedLanguage =
        language && typeof language === 'string' && language !== ''
          ? language.substring(0, 2)
          : 'en'

      return ctx.$axiosMarlon.get(`language-detection`, {
        params: {
          preferred_language: simplifiedLanguage,
          user_country: country
        }
      })
    },
    /* Reservations */
    getReservations(maintenanceId, from, to) {
      const fromNotation = ctx.$toMarlonDate(from)
      const toNotation = ctx.$toMarlonDate(to)

      return ctx.$axiosMarlon
        .get(`account/deadline/${maintenanceId}/reservations`, {
          params: { from_date: fromNotation, to_date: toNotation }
        })
        .catch((err) => {
          if (
            err &&
            err.response &&
            err.response.status === 400 &&
            err.response.data
          ) {
            return err.response.data
          }

          return {
            success: false,
            errors: ['marlon_issue']
          }
        })

      // possible error statuses: no_deadline_found, no_reservation_allowed, too_soon, not_enabled, no_maintance_package
    },
    lockReservation(reservationId, maintenanceId) {
      return ctx.$axiosMarlon
        .get(`account/reservation/${reservationId}/lock/${maintenanceId}`)
        .catch((err) => {
          if (
            err &&
            err.response &&
            err.response.status === 400 &&
            err.response.data
          ) {
            return err.response.data
          }

          return {
            success: false,
            errors: ['marlon_issue']
          }
        })

      // possible error statuses: reservation_is_locked, reservation_is_not_available
    },
    confirmReservation(reservationId, maintenanceId) {
      return ctx.$axiosMarlon
        .get(`account/reservation/${reservationId}/confirm/${maintenanceId}`)
        .catch((err) => {
          if (
            err &&
            err.response &&
            err.response.status === 400 &&
            err.response.data
          ) {
            return err.response.data
          }

          return {
            success: false,
            errors: ['marlon_issue']
          }
        })

      // possible error statuses: reservation_is_cancelled, reservation_is_already_confirmed, invalid_service_zone, no_maintenance_package, scheduler_not_enabled,
      // too_soon, no_reservation_allowed, service_zone_unavailable, invalid_customer, reservation_is_locked
    },
    getMonitoringConsent(consentId) {
      return ctx.$axiosMarlon
        .get(`consent/legal-text/${consentId}`)
        .catch((err) => {
          if (err && err.response && err.response.status === 404) {
            // The consent could not be found or is not linked to active customer
            return err.response
          }

          return {
            success: false,
            errors: ['marlon_issue']
          }
        })
    },
    confirmConsentPreference(consentId, installationId, status) {
      return ctx.$axiosMarlon
        .post(`consent/update/${consentId}`, {
          installation_id: installationId,
          status
        })
        .catch((err) => {
          if (err && err.response) {
            if (err.response.status === 404 || err.response.status === 403) {
              // 404 - One or multiple errors occurred: does_not_match, no_consent_requested, installation_unknown, consent_unknown
              // 403 - User does not match installation: installation_not_from_customer
              return err.response
            }
          }

          return {
            success: false,
            errors: ['marlon_issue']
          }
        })
    },
    getLegalTexts(
      professionalId,
      installationId,
      interventionType,
      isCustomerPwa
    ) {
      const eCare = isCustomerPwa ? '' : 'e-care/installation/'
      return ctx.$axiosMarlon
        .get(
          `${eCare}request-assistance/legal-texts?${
            eCare ? 'professional_id=' + professionalId : ''
          }&installation_id=${installationId}&intervention_type=${interventionType}`
        )
        .catch((error) => {
          if (error?.response?.status === 404) return error.response
          return { success: false, errors: ['marlon_issue'] }
        })
    },
    requestAssistance(body, isCustomerPwa) {
      const eCare = isCustomerPwa ? '' : 'e-care/installation/'
      return ctx.$axiosMarlon
        .post(`${eCare}request-assistance${eCare ? '' : '/installation'}`, body)
        .catch((error) => {
          if (error?.response?.status === 404) return error.response
          return { success: false, errors: ['marlon_issue'] }
        })
    },
    /* --------------------- */
    /* e-Care specific calls */
    eCareInstallationDetail: (installationId, professionalId) => {
      return ctx.$axiosMarlon
        .get(
          `e-care/installation/detail/${installationId}?professional_id=${professionalId}`
        )
        .catch((error) => {
          throw error
        })
    },
    /* --------------------- */
    sendInstallationHandover: (
      installationId,
      emailAddresNewOwner,
      handoverAllowed
    ) => {
      const data = {
        hand_over_allowed: handoverAllowed
      }
      if (emailAddresNewOwner) {
        data.email_address_new_owner = emailAddresNewOwner
      }
      return ctx.$axiosMarlon.post(
        `account/installation/${installationId}/handover`,
        data
      )
    }
  }
}

export default function(ctx, inject) {
  const isContext = !!(ctx && inject)
  const _ctx = isContext ? ctx : Vue.prototype
  const _marlonApi = marlonApi(_ctx)
  Vue.prototype.$marlonApi = _marlonApi
  if (isContext) {
    ctx.$marlonApi = _marlonApi
    inject('marlonApi', _marlonApi)
  } else {
    return _marlonApi
  }
}
